export default "__VITE_ASSET__gn20t256__"